import React, { useState } from 'react';
import { Grid, Paper, Box, Typography, Button } from '@mui/material';
import FilterAlt from '@mui/icons-material/FilterAlt';
import TrendsChart from './TrendsViewCharts/Trendchart';

const styles = {
  card: {
    width: '100%',
    padding: '20px',
    marginBottom: '20px',
    position: 'relative',
    borderRadius: '15px',
    background: 'linear-gradient(96deg, #050C28 0.29%, rgba(10,14,35,0.49) 98.84%)',
    boxShadow: 'inset 0 0 0 1.2px #313D4F',
    minHeight: '620px',
    color: '#fff'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px'
  },
  analyticsTitle: {
    display: 'flex',
    width: '163.088px',
    padding: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '18px'
  },
  tabsWrap: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '18px',
    borderBottom: '1px solid rgba(255,255,255,0.12)',
    paddingBottom: '8px',
    marginBottom: '12px'
  },
  tabBase: {
    position: 'relative',
    width: '161.971px',
    textAlign: 'center',
    cursor: 'pointer',
    padding: '8px 0 6px',
    userSelect: 'none'
  },
  indicator: {
    position: 'absolute',
    bottom: '-8px',
    left: 0,
    width: '161.971px',
    height: '3px',
    flexShrink: 0,
    background: '#36C5F0',
    borderRadius: '10px 10px 0 0'
  },
  tabLabel: (active) => ({
    fontSize: '14px',
    fontWeight: active ? 600 : 500,
    color: active ? '#FFFFFF' : 'rgba(255,255,255,0.65)'
  }),
  chartScroll: { width: '100%', height: '500px', overflow: 'auto' }
};

const LineChartToggle = () => {
  const [activeTab, setActiveTab] = useState('Trends View');

  const tabs = ['Trends View', 'Map View', 'Camera View'];

  return (
    <Grid item sx={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}>
      <Paper elevation={0} sx={styles.card}>
        {/* Header row: Analytics + Filter */}
        <Box sx={styles.headerRow}>
          <Box sx={styles.analyticsTitle}>Analytics</Box>

          {/* Filter Button */}
          <Button
            size="small"
            startIcon={<FilterAlt fontSize="small" />}
            sx={{
              height: 32,
              borderRadius: '10px',
              px: 1.75,
              gap: 0.75,
              color: '#FFFFFF',
              textTransform: 'none',
              fontSize: 13,
              lineHeight: 1,
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'transparent',
              '&:hover': {
                background: 'rgba(255,255,255,0.06)',
                borderColor: 'rgba(255,255,255,0.25)'
              }
            }}
          >
            Filter
          </Button>
        </Box>

        {/* Tabs */}
        <Box sx={styles.tabsWrap}>
          {tabs.map((label) => {
            const active = activeTab === label;
            return (
              <Box key={label} sx={styles.tabBase} onClick={() => setActiveTab(label)} aria-selected={active} role="tab">
                <Typography sx={styles.tabLabel(active)}>{label}</Typography>
                {active && <Box sx={styles.indicator} />}
              </Box>
            );
          })}
        </Box>

        {/* Body */}
        {activeTab === 'Trends View' ? (
          <div style={styles.chartScroll}>
            <TrendsChart />
          </div>
        ) : (
          <Grid />
        )}
      </Paper>
    </Grid>
  );
};

export default LineChartToggle;
